import { render, staticRenderFns } from "./Picks.vue?vue&type=template&id=031fa160"
import script from "./Picks.vue?vue&type=script&lang=js"
export * from "./Picks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports